import { createFileRoute } from "@tanstack/react-router"
import { PhoneVerificationPage } from "@/pages/PhoneVerificationPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/phone-verification"
)({
  component: PhoneVerificationPage,
})
